import { IAction, IMakePickState } from 'shared/interface/state';

import * as actionTypes from 'store/actionTypes';

export const initialMakePickState: IMakePickState = {
	isMakePickChoose: false
};

const makePickReducer = (state = initialMakePickState, action: IAction) => {
	switch (action.type) {
		case actionTypes.IS_MAKE_PICK_CHOOSE:
			return {
				...state,
				isMakePickChoose: action.payload
			};

		default:
			return state;
	}
};

export default makePickReducer;
